// Home page texts (fr), generated from khotoua-web/fr/index.html.
import type { HomeText } from './types';

const fr: HomeText = {
  header: {
    khotouaHomeLabel: "Khotoua — accueil",
    khotouaLogoAlt: "Logo Khotoua",
    menuLabel: "Menu",
    mainMenuLabel: "Menu principal",
    aboutUs: "À propos",
    learningContent: "Contenus",
    features: "Fonctionnalités",
    forSchools: "Écoles",
    testimonials: "Témoignages",
    plans: "Abonnements",
    contact: "Contact",
    arabicCurrent: undefined,
    arabicStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    francaisStyle: {
      color: "#FFFFFF",
      fontWeight: "800",
      textDecoration: "none",
    },
    francaisCurrent: "page",
    englishStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    englishCurrent: undefined,
    arCurrent: undefined,
    arStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    frStyle: {
      color: "#FFFFFF",
      fontWeight: "800",
      textDecoration: "none",
    },
    frCurrent: "page",
    enStyle: {
      color: "inherit",
      textDecoration: "none",
    },
    enCurrent: undefined,
    parentSpaceSoon: "L’Espace parents arrive…",
    parentSpace: "Espace parents",
    getTheApp: "Télécharger l’app",
  },
  hero: {
    learningThroughPlayAges: "\nApprendre en jouant · de 5 à 12 ans ",
    wePrepareYourChild: "Nous préparons votre enfant aux examens… ",
    whileProtectingTheirChildhood: "et préservons son enfance et son identité.",
    khotouaIsThePerfect: "Khotoua est le compagnon idéal des enfants du primaire pour apprendre de façon ludique et passionnante.",
    designedByEducationAnd: "Conçue par des experts en éducation et en technologie, selon les programmes scolaires officiels et les approches pédagogiques les plus récentes, elle parle à la génération Alpha : une génération née avec la technologie… et qui apprend dans sa langue.",
    tryTheFreeDemo: "Essayer la démo gratuitement",
    getTheAppNow: "Télécharger l’app maintenant",
    getItOn: "Disponible sur",
    getItOnAppSoon: "Bientôt sur l’App Store",
    getItOnAppgallerySoon: "Bientôt sur Huawei AppGallery",
    tryItOn: "Essayez sur",
    theWeb: "le web",
    khotouaSCharacterTheAlt: "Le personnage de Khotoua : le petit héros",
    khotouaSThreePillars: "Les 3 piliers de Khotoua",
    learningCulturePlayLabel: "Les piliers de Khotoua : apprendre, culture, jouer",
    learning: "Apprendre",
    culture: "Culture",
    play: "Jouer",
    discoverMoreLabel: "Descendre pour découvrir la suite",
    discoverMore: "Découvrir la suite",
  },
  about: {
    aboutUs: "À propos",
    ltrDir: "ltr",
    aGenerationThatLearns: "Une génération qui apprend autrement… mérite une application différente.",
    khotouaIsAnEducational: "Khotoua est une application éducative  qui réinvente l’apprentissage au primaire pour les enfants de 5 à 12 ans.",
    generationAlpha: "Génération Alpha · ",
    designedEspecially: "Conçue spécialement ",
    forGenerationAlpha: "pour la génération Alpha",
    aGenerationBornWith: ", une génération née avec les écrans, qui apprend ",
    throughImages: "par l’image,",
    movement: "le mouvement",
    andInteraction: "et l’interaction",
    andWhoNeedExperiences: ", et qui a besoin d’expériences à l’image de son monde, qui parlent à sa ",
    curiosity: "curiosité",
    byCombiningPlayWith: "En associant le jeu et la réalité augmentée, Khotoua offre une expérience immersive et interactive unique : des scénarios riches en jeux 2D et 3D, conçus pour développer les compétences cognitives de façon amusante et créative, en respectant le rythme de chaque enfant, pour apprendre avec plaisir et progresser avec confiance.",
    augmentedReality: "Réalité augmentée",
    artificialIntelligence: "Intelligence artificielle",
    t2d3dGames: "Jeux 2D / 3D",
    personalisedLearning: "Apprentissage personnalisé",
    childrenLearningWithVirtualAlt: "Des enfants qui apprennent avec la réalité virtuelle et augmentée dans la cour de l’école",
  },
  contents: {
    learningContent: "Contenus éducatifs",
    whatShallWeDo: "Que fait-on aujourd’hui ?",
    thisIsHowThe: "Voici comment l’application accueille votre enfant chaque jour : « Mes leçons » au cœur, entourées de Mes jeux, Mon encyclopédie, Ma boutique et Mes découvertes.",
    theKhotouaHomeScreenAlt: "L’écran d’accueil de Khotoua : que fait-on aujourd’hui ? Mes leçons au centre, entourées de Mes jeux, Mon encyclopédie, Ma boutique et Mes découvertes",
    homeScreenSpacesLabel: "Les espaces de l’écran d’accueil",
    myLessons: "Mes leçons",
    arabicFrenchEnglishMaths: "Arabe · Français · Anglais · Maths · Éveil scientifique",
    myGames: "Mes jeux",
    challengeAndCreativityAdventures: "Aventures de défi et de créativité",
    myEncyclopedia: "Mon encyclopédie",
    t3dInAugmentedReality: "En 3D, en réalité augmentée",
    myShop: "Ma boutique",
    financialLiteracyLearningTo: "Éducation financière : apprendre à gérer son argent de poche",
    myDiscoveries: "Mes découvertes",
    discoverAndLearnVideos: "Découvrir et apprendre : vidéos, contes et histoires",
  },
  demo: {
    insideTheApp: "Visite de l’application",
    aCompleteSafeWorldDir: "ltr",
    aCompleteSafeWorld: "Un monde complet et sûr… entre les mains de votre enfant",
    aSeriousGameWhere: "Un serious game que l’enfant vit ",
    theHero: "en héros",
    tryTheDemo: "Essayer la démo",
    khotouaWelcomeScreenWelcomeAlt: "Écran d’accueil de Khotoua : Bienvenue",
    welcome: "Bienvenue !",
    learningCulturePlayDiscovery: "Apprendre · Culture · Jouer · Découvrir — un compte enfant en une minute.",
    chooseYourTermScreenAlt: "Écran de choix du trimestre",
    inStepWithThe: "Au rythme de l’année scolaire",
    term1TheAdventure: "1er trimestre : le début de l’aventure · 2e : le voyage continue · 3e : vers le sommet.",
    chooseYourSchoolAdventureAlt: "Écran Choisis ton aventure scolaire : arabe, français, anglais, maths, éveil scientifique, questions-réponses",
    chooseYourSchoolAdventure: "Choisis ton aventure scolaire",
    arabicFrenchEnglishMaths: "Arabe, français, anglais, maths, éveil scientifique, questions-réponses.",
    myGamesScreenMathsAlt: "Écran Mes jeux : calcul, retrouver l’objet, mémoire, addition et ballon",
    challengeAndCreativityAdventures: "Aventures de défi et de créativité",
    mentalMathsMemory2048: "Calcul mental, mémoire, 2048… des points XP et des pièces qui motivent à progresser.",
    myEncyclopediaScreenInAlt: "Écran Mon encyclopédie en réalité augmentée : les animaux, les planètes, le corps humain",
    myEncyclopediaInAugmented: "Mon encyclopédie en réalité augmentée",
    theAnimalWorldA: "Le monde des animaux, voyage autour des planètes, découvre le corps humain… des livres qui prennent vie.",
    myDiscoveriesScreenVideosAlt: "Écran Mes découvertes : vidéos, contes, histoires",
    myDiscoveriesWhatWill: "Mes découvertes : que vais-je découvrir aujourd’hui ?",
    videosToWatchAnd: "Des vidéos pour regarder et apprendre, des contes en podcast et de nouvelles histoires à lire.",
    videosScreenIllustratedStoriesAlt: "Écran des vidéos : histoires illustrées",
    meaningfulIllustratedStories: "Des histoires illustrées pleines de sens",
    samiAndTheTwo: "Sami et l’ogre à deux têtes, la vieille cigogne, le coq trompé… des valeurs racontées avec plaisir.",
    characterDesignScreenWithAlt: "Écran de création du personnage, avec le solde de points et l’éducation financière",
    designYourCharacterAnd: "Crée ton personnage et défie tes amis",
    myBalanceThePrice: "« Mon solde − le prix = ce qu’il me reste » : une éducation financière pour gérer ses dépenses du quotidien.",
    mapOfTheSustainabilityAlt: "Carte du voyage de la durabilité à travers les continents",
    theSustainabilityJourneyAround: "Le voyage de la durabilité autour du monde",
    continentAfterContinentChildren: "Continent après continent, l’enfant découvre sa planète et apprend à la protéger.",
  },
  pedagogy: {
    features: "Fonctionnalités",
    whyDoParentsAnd: "Pourquoi les parents et les éducateurs choisissent Khotoua ?",
    featuresLabel: "Fonctionnalités",
    contentAlignedWithThe: "Des contenus conformes aux programmes scolaires",
    overcomingLearningDifficulties: "Surmonter les difficultés d’apprentissage",
    augmentedReality: "La réalité augmentée",
    bloomSTaxonomyOf: "La pyramide de Bloom des objectifs pédagogiques",
    whatKhotouaOffersParents: "Ce que Khotoua apporte aux parents",
    yourChildPlaysAnd: "Votre enfant joue… et apprend exactement ce qu’il étudie en classe.",
    allSubjectsFollowThe: "Toutes les matières proposées suivent le programme officiel du primaire, leçon par leçon. Et quand nous allons au-delà, c’est pour l’enrichir, approfondir la compréhension de votre enfant et élargir ses connaissances.",
    behindEveryPieceOf: "Derrière chaque contenu, une équipe pédagogique spécialisée conçoit, relit et vérifie, pour que votre enfant reçoive un apprentissage fiable et de la meilleure qualité.",
    screenTimeBecomesTime: "Le temps d’écran… devient du temps pour réussir à l’école.",
    usefulScreenTimeWith: "Un écran utile… l’esprit tranquille",
    parentSpace: "Espace parents",
    khotouaYourChildS: "Khotoua : le compagnon de votre enfant vers un apprentissage plus facile et plus agréable",
    khotouaStandsOutFor: "Khotoua sait accompagner les enfants qui rencontrent des difficultés d’apprentissage, grâce à des activités adaptées spécialement à leurs besoins, qui permettent aux parents et aux éducateurs d’apporter à chaque enfant le soutien qui lui convient.",
    weKeepImprovingKhotoua: "Nous faisons évoluer Khotoua en permanence pour qu’elle soit un compagnon fiable, qui accompagne les enfants dans un parcours éducatif unique et ludique : ils y découvrent leurs capacités, libèrent tout leur potentiel et surmontent leurs difficultés pas à pas, vers les meilleurs résultats.",
    overcomingDifficultiesIconColouredLabel: "Icône Surmonter les difficultés : des marches colorées que l’enfant gravit pas à pas jusqu’à l’étoile",
    theLessonLeavesThe: "La leçon sort du livre… et prend vie sous les yeux de votre enfant !",
    withAugmentedRealityLearning: "Avec la réalité augmentée, apprendre devient une véritable aventure : des planètes qui tournent, des animaux qui bougent, des personnages qui parlent, tous liés aux thèmes des leçons. Votre enfant s’en approche, les explore et interagit avec eux dans un monde en trois dimensions.",
    becauseWhatChildrenLive: "Parce que ce que l’enfant vit lui-même… ne s’oublie pas.",
    myEncyclopediaScreenInAlt: "Écran Mon encyclopédie en réalité augmentée : les animaux, les planètes, le corps humain",
    learningContentIsBuilt: "Les contenus sont construits de façon progressive, selon la pyramide de Bloom :",
    theLearnerExploresKnowledge: "L’élève explore la connaissance, la mémorise et la restitue.",
    practisesActivitiesThatEnsure: "Il pratique des activités qui assurent une compréhension complète de cette connaissance.",
    appliesWhatTheyHave: "Il applique ses acquis dans des situations de la vie réelle, de façon progressive.",
    analysesTheKnowledgeAnd: "Il analyse les savoirs et savoir-faire acquis et les recompose pour les intégrer.",
    evaluatesWhatTheyHave: "Il évalue ses acquis, leur donne une valeur et porte un jugement objectif.",
    inventsAndCreatesA: "Il invente et crée une production fondée sur ses acquis, en contenu comme en démarche.",
    bloomSTaxonomyIconLabel: "Icône de la pyramide de Bloom : mémoriser, comprendre, appliquer, analyser, évaluer, créer",
    remember: "Mémoriser",
    understand: "Comprendre",
    apply: "Appliquer",
    analyse: "Analyser",
    evaluate: "Évaluer",
    create: "Créer",
    bloomSTaxonomy: "Pyramide de Bloom",
    whatKhotouaOffersParents2: "Ce que Khotoua apporte aux parents",
    youDonTNeed: "Pas besoin d’être enseignant… Khotoua est avec vous.",
    seeTheirProgress: "Vous voyez ses progrès :",
    whatTheyHaveDone: " ce qu’il a fait, ce qu’il maîtrise et là où il a besoin de vous.",
    trustEveryLesson: "Vous avez confiance en chaque leçon :",
    contentAlignedWithThe2: " un contenu conforme au programme officiel, conçu par des spécialistes de l’éducation.",
    followThemFromYour: "Vous le suivez depuis votre espace :",
    theParentSpaceBrings: " l’« Espace parents » réunit tout l’apprentissage de votre enfant en un seul endroit.",
    peaceOfMindAbout: "Vous êtes rassuré sur son temps :",
    aSafeSpaceDesigned: " un espace sûr conçu pour les enfants, où chaque minute est utile.",
    youLoveThemWe: "Vous l’aimez… nous vous aidons à le faire réussir.",
    khotouaMyProfileAndAlt: "Écran Mon profil et Espace parents de Khotoua",
    ourTeachingApproach: "Notre approche pédagogique",
    variedLearningContent: "Des contenus éducatifs variés",
    wePrepareYourChild: "Nous préparons votre enfant aux examens… et à la vie.",
    variedEducationalActivitiesAnd: "Des activités et des jeux éducatifs variés",
    linkedToTheOfficial: "liés au programme officiel, pour acquérir des connaissances et les utiliser au quotidien.",
    valuesToGrowUp: "Des valeurs pour grandir",
    citizenshipRespectForOthers: "La citoyenneté, le respect de l’autre, les droits de l’homme et les droits de l’enfant.",
    anEyeOnThe: "Un regard sur le monde",
    theyDiscoverTheIssues: "Il découvre les enjeux de son époque, de la protection de l’environnement aux objectifs de développement durable, et prépare son avenir avec confiance.",
    khotoua: "Khotoua,",
    yourChildSWindow: " la fenêtre de votre enfant sur un monde qui change… pour qu’il prenne part à ce changement.",
    joinUsTodayOn: "Rejoignez-nous dès aujourd’hui pour un parcours éducatif passionnant et ludique avec Khotoua.",
    helpYourChildrenDiscover: "Aidez vos enfants à découvrir leurs talents et à réaliser leurs rêves grâce à un apprentissage innovant et personnalisé.",
    getTheAppNow: "Télécharger l’app maintenant",
    tryTheDemo: "Essayer la démo",
  },
  schools: {
    forSchoolsAndInstitutions: "Écoles et institutions",
    aPlatformThatAdapts: "Une plateforme qui s’adapte au programme de votre école",
    withAFlexibleContent: "Grâce à un système de gestion de contenu (CMS) flexible, l’école ou le ministère ajoute ses leçons, ses langues et ses valeurs locales sans aucune programmation. Khotoua est partenaire d’écoles tunisiennes et d’un réseau qui suit le système Cambridge.",
    requestADemoFor: "Demander une démo pour mon école",
    downloadTheBrochure: "Télécharger la brochure",
    customisableContent: "Contenu personnalisable",
    modulesAddedToFit: "Des modules ajoutés selon les besoins de l’établissement.",
    classTracking: "Suivi de la classe",
    toBeConfirmedA: "[À confirmer] Tableau de suivi pour l’enseignant, par classe et par élève.",
    multilingual: "Multilingue",
    arabicFrenchAndEnglish: "Arabe, français et anglais.",
    trainingAndSupport: "Formation et accompagnement",
    weSupportTeachersIn: "Nous accompagnons les enseignants pour intégrer l’application en classe.",
  },
  trust: {
    testimonials: "Témoignages",
    whatDoTeachersSay: "Ce qu’en disent les enseignants ?",
    inTheAgeOf: "À l’ère de la technologie, deux pas sont essentiels : un pas vers le savoir et un pas vers la technologie. C’est cela, Khotoua.",
    habibaRais: "Habiba Rais",
    arabicTeacherForBeginners: "Enseignante d’arabe pour débutants",
    funAndLearningOn: "Plaisir et apprentissage dans un voyage unique pour découvrir le monde de façon passionnante et amusante. Voilà Khotoua, l’innovation tunisienne qui réunit jeux et apprentissage… pour renforcer les notions avec une évaluation individuelle et des rapports de progression. Félicitations !",
    ayaEnnaoui: "Aya Ennaoui",
    primarySchoolTeacher: "Professeure des écoles primaires",
    aSolidStepThat: "Un pas solide pour hisser l’élève vers l’excellence, bâtir ses connaissances sur des bases solides et le faire progresser dans le plaisir, grâce à des exercices qui améliorent ses acquis de façon remarquable et le mènent à la réussite.",
    najmeddineJarfel: "Najmeddine Jarfel",
    retiredSeniorPrimarySchool: "Professeur principal des écoles primaires, hors classe, retraité",
    modernInnovativeLearningCapsules: "De véritables capsules pédagogiques modernes et innovantes, conformes aux programmes officiels, qui touchent les intelligences propres à chaque élève et ses styles d’apprentissage. Elles traitent les difficultés et développent les compétences de l’élève, avec une grande facilité d’utilisation.",
    mohamedZiraoui: "Mohamed Ziraoui",
    civicEducationTeacher: "Enseignant d’éducation civique",
    everyBeginningStartsWith: "Chaque début commence par un premier pas. Et Khotoua sera le premier pas vers l’excellence.",
    salmaHabibi: "Salma Habibi",
    seniorPrimarySchoolTeacher: "Professeure principale hors classe des écoles primaires",
    parentsHaveDownloadedKhotoua: "parents ont téléchargé Khotoua…",
  },
  pricing: {
    plans: "Abonnements",
    startForFreeAnd: "Commencez gratuitement… et continuez en famille",
    termly6MonthsXLabel: "Durée de l’abonnement",
    termly: "Trimestriel",
    t6MonthsX: "Semestriel · [-X %]",
    yearlyX: "Annuel · [-X %]",
    discovery: "Découverte",
    toTryWithYour: "Pour essayer avec votre enfant",
    t0Tnd: "0 DT",
    theDemo: "La démo",
    freeActivities: " Des activités gratuites",
    oneChildProfile: "Un profil enfant",
    theFirstLessonOf: "La première leçon de chaque matière offerte",
    getTheAppAnd: "Télécharger l’app et essayer",
    mostPopular: "Le plus choisi",
    family: "Famille",
    allOfKhotouaS: "Tous les univers de Khotoua pour tous les frères et sœurs",
    termlyPriceTnd: "[Prix trimestriel] DT",
    term: "/ trimestre",
    allSixLearningSpaces: "Les six espaces éducatifs",
    augmentedRealityAndThe: "La réalité augmentée et l’encyclopédie 3D",
    parentSpaceAndProgress: "L’Espace parents et les rapports de progression",
    upToNumberChild: "Jusqu’à [nombre] profils enfants",
    subscribeNow: "S’abonner",
    schoolsAndInstitutions: "Écoles et institutions",
    forClassesNetworksAnd: "Pour les classes, les réseaux et les ministères",
    onRequest: "Sur devis",
    licencesPerPupilOr: "Licences par élève ou par établissement",
    contentManagementSystemCms: "Système de gestion de contenu (CMS)",
    teacherTrainingAndSupport: "Formation et accompagnement des enseignants",
    talkToOurTeam: "Parler à notre équipe",
  },
  contact: {
    contact: "Contact",
    takeTheFirstStep: "Faites le premier pas avec Khotoua",
    customerService: "Service client",
    messageUsOnWhatsapp: "Écrivez-nous sur WhatsApp",
    email: "E-mail",
    socialMedia: "Réseaux sociaux",
    instagram: "Instagram",
    facebook: "Facebook",
    tiktok: "TikTok",
    linkedin: "LinkedIn",
    youtube: "YouTube",
    requestADemoLabel: "Demander une démo",
    requestADemo: "Demander une démo",
    iAmA: "Je suis",
    parent: " Parent",
    school: "École",
    institutionPartner: " Institution / partenaire",
    fullName: "Nom et prénom",
    phone: "Téléphone",
    ltrInputStyle: {
      minHeight: "50px",
      borderRadius: "14px",
      border: "1.5px solid #B8C0EA",
      padding: "0 14px",
      textAlign: "left",
    },
    childSSchoolYear: "Niveau scolaire de l’enfant",
    chooseAYear: "Choisir le niveau…",
    preSchool: "Préparatoire",
    primaryYear1: "1re année primaire",
    primaryYear2: "2e année primaire",
    primaryYear3: "3e année primaire",
    primaryYear4: "4e année primaire",
    primaryYear5: "5e année primaire",
    primaryYear6: "6e année primaire",
    schoolName: "Nom de l’école",
    eGPrivateSchoolPlaceholder: "Ex. : École … privée",
    institutionName: "Nom de l’institution",
    sendMyRequest: "Envoyer ma demande",
    fieldsMarkedWith: "Les champs marqués d’un ",
    areRequiredYourData: " sont obligatoires. Vos données restent confidentielles. ",
    privacyPolicy: "Politique de confidentialité",
  },
  footer: {
    yourChildSJourney: "Le chemin de votre enfant vers la réussite commence par un pas… que ce soit aujourd’hui !",
    getItOn: "Disponible sur",
    getItOnAppSoon: "Bientôt sur l’App Store",
    getItOnAppgallerySoon: "Bientôt sur Huawei AppGallery",
    tryItOn: "Essayez sur",
    theWeb: "le web",
    khotouaLogoAlt: "Logo Khotoua",
    everyAchievementStartsWith: "Chaque réussite commence par un pas…",
    aboutUsLearningContentLabel: "Liens",
    aboutUs: "À propos",
    learningContent: "Contenus",
    features: "Fonctionnalités",
    testimonials: "Témoignages",
    termsAndConditionsPrivacyLabel: "Informations",
    termsAndConditions: "Conditions générales",
    privacyPolicy: "Politique de confidentialité",
    contact: "Contact",
    producedBy: "Produit par :",
    dmNovaOfficialWebsiteLabel: "DM NOVA — site officiel",
    t2026KhotouaDmNova: "© 2026 Khotoua · DM NOVA. Tous droits réservés.",
    privacySettings: "Paramètres de confidentialité",
  },
  toast: {
    comingSoon: "Bientôt…",
    theParentSpaceIs: "L’Espace parents arrive…",
  },
  whatsapp: {
    whatsappLabel: "Écrivez-nous sur WhatsApp",
    whatsapp: "WhatsApp",
  },
  scrollNext: {
    keepScrollingLabel: "Continuer à descendre",
  },
};

export default fr;
